import { ReactNode, useEffect, useRef, useState } from "react";
import { useClientConfigQuery } from "../queries/client-config-queries";
import MaintenancePage from "./MaintenancePage";
import RefreshBrowserPage from "./RefreshBrowserPage";

export const STUDIO_VERSION = 19;

const BYPASS_CODE = "kouhia";

export default function ClientConfigGuard({
  children,
}: {
  children: ReactNode;
}) {
  const { data } = useClientConfigQuery();
  const [bypass, setBypass] = useState(false);
  const bufferRef = useRef("");

  const isBlocked =
    !!data?.maintenanceEndsAt ||
    (!!data && data.minStudioVersion > STUDIO_VERSION);

  useEffect(() => {
    if (!isBlocked || bypass) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key.length !== 1) return;
      bufferRef.current = (bufferRef.current + event.key.toLowerCase()).slice(
        -BYPASS_CODE.length,
      );
      if (bufferRef.current === BYPASS_CODE) {
        setBypass(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isBlocked, bypass]);

  if (bypass) {
    return children;
  }

  if (data?.maintenanceEndsAt) {
    return <MaintenancePage maintenanceEndsAt={data.maintenanceEndsAt} />;
  }

  if (data && data.minStudioVersion > STUDIO_VERSION) {
    return <RefreshBrowserPage />;
  }

  return children;
}
